import { User } from 'oidc-client';
import React, { useContext, useLayoutEffect, useState } from 'react'
import { Redirect } from 'react-router-dom'
import { getUserInfo, signinRedirectCallback } from '../services/UserService';
import { store } from '../store';

const SignIn = () => {
    const [dataLoadedState, setIsDataLoaded] = useState(false);
    const globalState = useContext(store);
    const { dispatch } = globalState;

    useLayoutEffect(() => {
        signinRedirectCallback(dispatch)
            .then(() => getUserInfo())
            .then((u: User | null) => {
                if (u && u.profile.role_extended) {
                    fetch(`${process.env.REACT_APP_CSEC_SERVICE_CARRIERS_ENDPOINT}/?userId=${u.profile.sub}`, {
                        method: 'GET',
                        headers: {
                            'Authorization': `Bearer ${u.access_token}`
                        },
                    }).then(
                        (response) => response.text()
                            .then((text) => text as string)
                            .then((data) => {
                                u.state = data;
                                dispatch({ type: "set admin status", value: u });
                            })
                    ).catch(() =>
                            <Redirect to="/" />);
                } else {
                    console.log(new Error('User does not have permission to view this resource'));
                    setIsDataLoaded(true);
                }
            })
            .then(() => {
                setIsDataLoaded(true);
            })
            .catch(() =>
                <Redirect to="/" />)
    }, [])

    return (
        <React.Fragment>
            {
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
                    {
                        globalState.state.appState.user &&
                        <div>
                            <Redirect to="/" />
                        </div>
                    }
                </div>
            }
        </React.Fragment>
    )
}


export default SignIn